import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

import LoadingSpinner from '../partials/LoadingSpinner';
import PageHeader from '../partials/PageHeader';
import FeatureCard from '../partials/FeatureCard';

const SuggestedPurchaseOrders = ({ payload }) => {
  return(
    <>
      <PageHeader stripeBackground='#5bc6cc' helpLink="ecwid/suggest-purchase-orders-2" />
      <div className="settings-page cf">
        <div className="settings-page__header">
          <div className="named-area">
            <div className="named-area__header">
              <div className="named-area__titles">
                <div className="named-area__title">Suggested Purchase Orders</div>
              </div>
              <div className="named-area__description">
                <p>Set thresholds and target inventories in the "Set Thresholds" tool, then use the "Suggest Purchase Orders" tool to generate purchase orders from a supplier, to your store in a couple of clicks.</p>
              </div>
            </div>
            <div className="named-area__body">

              <FeatureCard
                title="Suggested Purchase Orders"
                description="Create purchase order suggestions from thresholds set in the Set Thresholds tool. Compare thresholds to on hand inventory and incoming inventory from other purchase orders."
                buttonText="Suggested Purchase Orders"
                image={
                  <svg xmlns="http://www.w3.org/2000/svg" width="150" height="150" fill="#000000" viewBox="0 0 32 32">
                    <g>
                      <path d="M17.9,9.9c-4.6,0.9-6,2.3-6.9,6.9c-0.9-4.6-2.3-6-6.9-6.9C8.7,9,10.1,7.6,11,3C11.9,7.6,13.3,9,17.9,9.9z"/>
                    </g>
                    <g>
                      <path d="M21.8,25c-3.2,0.6-4.1,1.6-4.8,4.8c-0.6-3.2-1.6-4.1-4.8-4.8c3.2-0.6,4.1-1.6,4.8-4.8
                        C17.6,23.4,18.6,24.4,21.8,25z"/>
                    </g>
                    <g>
                      <path d="M29,15c-2.6,0.5-3.4,1.3-3.9,3.9c-0.5-2.6-1.3-3.4-3.9-3.9c2.6-0.5,3.4-1.3,3.9-3.9C25.6,13.7,26.4,14.5,29,15
                        z"/>
                    </g>
                    <line x1="5" y1="23" x2="5" y2="23"/>
                    <line x1="28" y1="6" x2="28" y2="6"/>
                  </svg>
                }
                linkUrl="/generate_suggestions"
                stripeBackground='#5bc6cc'
              />

              <FeatureCard
                title="Set Thresholds"
                description="Create thresholds for your store. Set target inventories as well as low inventory and critical inventory level thresholds"
                buttonText="Set Thresholds"
                image={
                <svg height="150" width="150" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" fill="#000000">
                  <g>
                    <path d="M463.515,236.436c-4.627-49.732-26.735-94.499-60.104-127.839c-33.341-33.369-78.115-55.484-127.846-60.112V0
                      h-39.129v48.485c-49.717,4.627-94.491,26.742-127.831,60.112c-33.37,33.34-55.477,78.108-60.12,127.839H0v39.129h48.484
                      c4.643,49.732,26.75,94.498,60.12,127.838c33.34,33.362,78.114,55.477,127.831,60.112V512h39.129v-48.484
                      c49.731-4.636,94.505-26.75,127.846-60.112c33.369-33.34,55.477-78.107,60.104-127.838H512v-39.129H463.515z M422.953,275.565
                      c-4.47,38.62-21.964,73.172-48.069,99.312c-26.148,26.112-60.692,43.592-99.32,48.07v-69.339h-39.129v69.332
                      c-38.613-4.47-73.172-21.95-99.305-48.062c-26.119-26.14-43.599-60.692-48.069-99.312h69.332v-39.129H89.061
                      c4.47-38.621,21.95-73.172,48.069-99.313c26.134-26.112,60.692-43.599,99.305-48.069v69.339h39.129V89.054
                      c38.627,4.47,73.171,21.957,99.32,48.069c26.105,26.141,43.599,60.692,48.069,99.313h-69.346v39.129H422.953z"/>
                    <path d="M256.007,233.993C243.843,233.993,234,243.85,234,256c0,12.15,9.843,22.007,22.008,22.007
                      c12.15,0,22.007-9.858,22.007-22.007C278.014,243.85,268.157,233.993,256.007,233.993z"/>
                  </g>
                </svg>
                }
                linkUrl="/thresholds"
                stripeBackground='#5bc6cc'
              />

            </div>
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(SuggestedPurchaseOrders);